import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import Flickity from 'flickity-imagesloaded';
const migrationsLogin = {
  init(config) {
    this.closeLockout();
    this.handleShowHidePassword();
    this.handleFormValidation();
    this.handleFormSubmit();
    this.enableFlickity();
  },
  // Add show/hide functionality to password field
  handleShowHidePassword() {
    const togglePass = $('#toggle-password');
    const passField = $('#Password');
    const toggleClasses = 'mysites nonvisible';
    togglePass
      .on('mousedown touchstart', function() {
        $(this).text('visibility');
        $(this).removeClass(toggleClasses);
        passField.attr('type', 'text');
      })
      .on('mouseup touchend keyup', function() {
        $(this).text('');
        $(this).addClass(toggleClasses);
        passField.attr('type', 'password');
      })
      .on('mouseout focusout', function() {
        $(this).text('');
        $(this).addClass(toggleClasses);
        passField.attr('type', 'password');
      });

    $('#toggle-password').on('keydown', function (e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        $(this).text('visibility');
        $(this).removeClass('mysites nonvisible');
        passField.attr('type', 'text');
      }
    });
  },
  // Creates a mutation observer to watch for class changes on the login felds.
  // This will trigger the error class on the container.
  handleFormValidation() {
    const mut = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        const errorValidationClass = 'input-validation-error';
        const target = $(mutation.target);
        const targetField = target.closest('.field');
        if (mutation.attributeName === 'class') {
          if (target.hasClass(errorValidationClass)) {
            targetField.addClass('error');
          } else {
            targetField.removeClass('error');
          }
        }
      });
    });
    //  Dictates which elements to apply the mutations to.
    if ($('#my-account-login .user-field input').length) {
      mut.observe(
        document.querySelector('#my-account-login .user-field input'),
        {
          attributes: true,
        }
      );
    }
    if ($('#my-account-login .pass-field input').length) {
      mut.observe(
        document.querySelector('#my-account-login .pass-field input'),
        {
          attributes: true,
        }
      );
    }
  },
  closeLockout() {
    $('.close-lockout').on('click', function () {
      // Close modal
      $(this).closest('#lockout-modal').removeClass('visible active');
      $('body').removeClass('dimmable dimmed scrolling');
    });
  },
  // Handle user login on submit
  handleFormSubmit() {
    $('#loginForm').bind('submit', function(e) {
      var $form = $(this);
      var $formSubmit = $form.find('button[type="submit"]');
      var $ajaxRequestError = $('.ajax-server-error');
      e.preventDefault();
      if ($form.valid()) {
        const elements = {
          $validationSummary: $('#loginErrorMessage ul'),
          $errorMessage: $('#loginErrorMessage'),
          $lockoutModal: $('#lockout-modal'),
        };
        $formSubmit.addClass('loading').prop('disabled', true);
        $.ajax({
          type: 'POST',
          url: '/login',
          data: $form.serialize(),
          success: function(result) {
            $formSubmit.removeClass('loading').prop('disabled', false);
            if (result.Type === 'ErrorInvalidCredentials') {
              $('[data-valmsg-summary=true]')
                  .removeClass('validation-summary-valid')
                  .addClass('validation-summary-errors');
              elements.$validationSummary.empty().append('<li>' + result.Message + '</li>');
              elements.$errorMessage.show();
            } else if (result.Type === 'ErrorUserIsLocked') {
              elements.$lockoutModal.addClass('visible active');
              if (elements.$lockoutModal.length) $('body').addClass('dimmable dimmed scrolling');
              elements.$errorMessage.hide();
              elements.$validationSummary.empty();
            } else if (result.Type === 'LoginSucceeded') {
              if (window.dataLayer && result.UserId > 0) {
                window.dataLayer.push({
                  event: 'login',
                  userid: result.UserId.toString(),
                });
              }
              window.location.href = result.RedirectUrl;
            }
          },
          error: function (request, status, error) {
            $formSubmit.removeClass('loading').prop('disabled', false);
            $ajaxRequestError.show();
          },
          dataType:'json',
        });
        return false;
      }
    });
  },
  enableFlickity() {
    const el = document.querySelector('.carousel');
    const flickity = new Flickity(el, {
      cellAlign: 'left',
      cellSelector: 'li',
      imagesLoaded: true,
      percentPosition: true,
      prevNextButtons: false,
      watchCSS: true,
      wrapAround: true,
      adaptiveHeight: false,
    });
    return flickity;
  },
};
export default migrationsLogin;



// WEBPACK FOOTER //
// ./src/apps/acuraca/login.migrations.js